import i18n from '@/plugins/i18n';
import type { DataTableHeader } from '@/types/vuetify';

export function createLivePageHeadersBasketball(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            key: 'data-table-group',
            cellProps: {
                class: 'no-padding-x',
            },
            headerProps: {
                class: 'group-header',
            },
            sortable: false,
            minWidth: 0,
            width: 0,
            nowrap: true,
        },
        {
            title: t('pregame.date'),
            value: 'eventDate',
            key: 'eventDate',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('live.timeScore'),
            value: 'timeScore',
            key: 'timeScore',
            align: 'center',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pregame.game'),
            value: 'gameInfo',
            key: 'gameInfo',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pregame.bookmaker'),
            value: 'bookmakerId',
            key: 'bookmakerId',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: '1',
            value: 'mlPriceHome',
            key: 'mlPriceHome',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.moneyline'),
        },
        {
            title: '2',
            value: 'mlPriceAway',
            key: 'mlPriceAway',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.moneyline'),
        },
        {
            title: t('pregame.spreadLine'),
            value: 'spreadLine',
            key: 'spreadLine',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.spread'),
        },
        {
            title: t('pregame.spreadPriceHome'),
            value: 'spreadPriceHome',
            key: 'spreadPriceHome',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.spread'),
        },
        {
            title: t('pregame.spreadPriceAway'),
            value: 'spreadPriceAway',
            key: 'spreadPriceAway',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.spread'),
        },
        {
            title: t('pregame.pointsLine'),
            value: 'goalLine',
            key: 'goalLine',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.points'),
        },
        {
            title: t('pregame.goalPriceOver'),
            value: 'goalPriceOver',
            key: 'goalPriceOver',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.points'),
        },
        {
            title: t('pregame.goalPriceUnder'),
            value: 'goalPriceUnder',
            key: 'goalPriceUnder',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.points'),
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 96,
            cellProps: {
                class: 'pl-0 pr-1',
            },
        },
    ];
}
